<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="600">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs1>
        </v-flex>
        <v-flex xs10 style="text-align: left;">
          <span>{{$parent.popup.data.CreateDate}}</span>
        </v-flex>
        <v-flex xs1>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs6>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              כותרת יומן
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="$parent.popup.data.Title" style="width: 200px;" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              תיאור
            </v-flex>
            <v-flex xs9>
              <textarea type="text" v-model="$parent.popup.data.Info" style="width: 200px;" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              פרויקט
            </v-flex>
            <v-flex xs9>
              <span class="custom-dropdown custom-dropdown--white" style="width: 200px;">
                <select v-model="$parent.popup.data.ProjectKey" class="custom-dropdown__select custom-dropdown__select--white" @change="setProjectName">
                  <!--<option value="">בחר פרויקט</option>-->
                  <option v-for="project in projects" :value="project['.key']">{{project.Name}}</option>
                </select>
              </span>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs2 right>
            </v-flex>
            <v-flex xs8 style="text-align:right;">
              <input type="checkbox" v-model="$parent.popup.data.SendToCustomer" class="w3-check"> שלח העתק יומי לרוכש
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs2 right>
            </v-flex>
            <v-flex xs8 style="text-align:right;">
              <input type="checkbox" v-model="$parent.popup.data.SendToInspectors" class="w3-check"> שלח העתק יומי למפקח/ים
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs2 right>
            </v-flex>
            <v-flex xs8 style="text-align:right;">
              <input type="checkbox" v-model="$parent.popup.data.SendToContractors" class="w3-check"> שלח העתק יומי למנהל עבודה
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;" v-if="!$root.isCustomer">
            <v-flex xs3 right>
              לקוח
            </v-flex>
            <v-flex xs9>
              <span class="custom-dropdown custom-dropdown--white" style="width: 200px;">
                <select v-model="$parent.popup.data.CustomerKey" class="custom-dropdown__select custom-dropdown__select--white" @change="setCustomerName">
                  <option v-for="customer in customers" :value="customer['.key']">{{customer.FullName}}</option>
                </select>
              </span>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              מפקח
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="txtSearchInspector" style="width: 200px;" placeholder="חפש לפי תעודת זהות" />
              <div v-if="filteredInspectors.length" class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in filteredInspectors" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="addUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'הוסף מפקח' }">add</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 10px;" v-if="selectedInspectors && selectedInspectors.length">
            <v-flex xs3 right>
            </v-flex> 
            <v-flex xs9>
              <div class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in selectedInspectors" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;font-size: 12px!important; font-style:italic;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="removeUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'מחק מפקח' }">remove</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              מנהל עבודה
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="txtSearchContractor" style="width: 200px;" placeholder="חפש לפי תעודת זהות" />
              <div v-if="filteredContractors.length" class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in filteredContractors" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="addUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'הוסף מנהל עבודה' }">add</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 10px;"  v-if="selectedContractors && selectedContractors.length">
            <v-flex xs3 right>
            </v-flex>
            <v-flex xs9>
              <div class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in selectedContractors" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;font-size: 12px!important; font-style:italic;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="removeUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'מחק מנהל עבודה' }">remove</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              משקיף
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="txtSearchObserver" style="width: 200px;" placeholder="חפש לפי תעודת זהות" />
              <div v-if="filteredObservers.length" class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in filteredObservers" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="addUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'הוסף משקיף' }">add</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 10px;" v-if="selectedObservers && selectedObservers.length">
            <v-flex xs3 right>
            </v-flex>
            <v-flex xs9>
              <div class="custom-dropdown__select custom-dropdown__select--white" style="border: 1px solid #ccc; padding: 10px; margin-right: 10px; max-height: 150px; overflow-y: scroll; overflow-x: hidden;">
                <v-layout row wrap v-for="item in selectedObservers" class="divAddedUser">
                  <v-flex xs10 right style="text-align: right;font-size: 12px!important; font-style:italic;">
                    {{item.FullName}}
                  </v-flex>
                  <v-flex xs2>
                    <v-icon v-if="!item.IsConfirmed" @click="removeUser(item)" class="btnAddSmall" v-tooltip:right="{ html: 'מחק משקיף' }">remove</v-icon>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
        
        <v-flex row wrap style="padding: 10px 10px 10px 10px;">
          <span class="error" v-show="error">* {{error}}</span>
        </v-flex>
        <v-flex actions style="padding: 20px 10px 10px 10px;">
          <v-btn outline small class="green green--text ml-3" @click.native="save">
            שמירה
            <v-icon left>check</v-icon>
          </v-btn>
          <v-btn outline small class="red red--text ml-2" @click.native="cancel">
            ביטול
            <v-icon left>block</v-icon>
          </v-btn>
        </v-flex>
</v-card>
  </v-dialog>
</template>

<script>
  import { db } from '../firebase';
  var projectsRef = db.ref('Projects');
  var usersRef = db.ref('Users');

  export default {
    name: 'PopupDiary',
    data() {
      return {
        error: '',
        txtSearchInspector: '',
        txtSearchObserver: '',
        txtSearchContractor: '',
        customers: [],
        //contractors: [],
        //inspectors: [],
        //observers: [],
        projects: [],
        users: [],
        filteredInspectors: [],
        filteredContractors: [],
        filteredObservers: [],
        selectedInspectors: [],
        selectedContractors: [],
        selectedObservers: [],
        AddedUsers: {},
      }
    },
    firebase: function () {
      var vm = this;
      return {
        customers: usersRef.orderByChild("Type").equalTo("רוכש"),
        users: usersRef.orderByKey(),
        projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key'])
      }
    },
    created() {
      this.$Log("Vue [PopupDiary] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupDiary] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupDiary] is mounted ...");
      this.refreshFiltered();
      this.refreshSelected();
    },
    updated() {
      this.$Log("Vue [PopupDiary] is updated ...");
    },
    computed: {
    },
    watch: {
      txtSearchInspector(val) {
        this.refreshFiltered();
      },
      txtSearchContractor(val) {
        this.refreshFiltered();
      },
      txtSearchObserver(val) {
        this.refreshFiltered();
      },
      '$parent.popup.isVisible'(val) {
        if (val) {
          this.refreshAddedUsers();
          this.refreshFiltered();
          this.refreshSelected();
        }
      }
      //'$parent.popup.data.AddedUsers'(val) {
      //  var vm = this;
      //  if (val) {
      //    var keys = Object.keys(vm.$parent.popup.data.AddedUsers);
      //    for (var k = 0; k < keys.length; k++) {
      //      let key = keys[k];

      //      for (var u = 0; u < vm.users.length; u++) {
      //        vm.users[u].IsSelected = false;
      //        vm.users[u].IsConfirmed = vm.$parent.popup.data.AddedUsers[key].IsConfirmed;
      //        if (vm.users[u]['.key'] == key) {
      //          vm.users[u].IsSelected = true;
      //        }
      //      }
      //    }
      //  }
      //  else {
      //    for (var u = 0; u < vm.users.length; u++) {
      //      vm.users[u].IsSelected = false;
      //    }
      //  }

      //  //vm.$forceUpdate();
      //  vm.refreshSelected();
      //}
    },
    methods: {
      refreshAddedUsers() {
        var vm = this;

        for (var u = 0; u < vm.users.length; u++) {
          vm.users[u].IsSelected = false;
        }

        if (vm.$parent.popup.data.AddedUsers) {
          var keys = Object.keys(vm.$parent.popup.data.AddedUsers);
          for (var k = 0; k < keys.length; k++) {
            let key = keys[k];
            console.log(">>>>>>>>>>>>  AddedUsers [key] = " + key);
            for (var u = 0; u < vm.users.length; u++) {

              console.log(vm.users[u]['.key'] + " == " + key + " [" + (vm.users[u]['.key'] == key) + "]")

              if (vm.users[u]['.key'] == key) {
                vm.users[u].IsConfirmed = vm.$parent.popup.data.AddedUsers[key].IsConfirmed;
                vm.users[u].IsSelected = true;
              }
            }
          }
        }

        for (var u = 0; u < vm.users.length; u++) {
          console.log(vm.users[u].FullName + " >>> " + vm.users[u]['.key'] + " >>> " + vm.users[u].IsSelected + " >>> ")
        }
      },
      refreshFiltered() {
        this.filteredInspectors = this.filterUsers("מפקח", this.txtSearchInspector, false);
        this.filteredContractors = this.filterUsers("מנהל עבודה", this.txtSearchContractor, false);
        this.filteredObservers = this.filterUsers("משקיף", this.txtSearchObserver, false);
      },
      refreshSelected() {
        this.selectedInspectors = this.filterUsers("מפקח", "", true);
        this.selectedContractors = this.filterUsers("מנהל עבודה", "", true);
        this.selectedObservers = this.filterUsers("משקיף", "", true);
      },
      filterUsers(type, searchTxt, selected) {
        var vm = this;
        var result = [];
        if (selected) {
          result = vm.users.filter(function (row) {
            if (row.Type == type && row.IsSelected) {
              console.log("filterUsers >>> " + type + " selected = " + selected)
              console.log(JSON.stringify(row))
            }
            return (row.Type == type && row.IsSelected);
          });
        }
        else if (searchTxt.length > 0) {
          var result = [];
          try {
            result = vm.users.filter(function (row) {
              if (row.Type == type && !row.IsSelected) {
                return (row.Identity.trim().toLowerCase().indexOf(searchTxt.trim().toLowerCase()) > -1);
              }
            }).slice(0, 5);
          }
          catch (e) {
            result = [];
          }
        }
        else {
          result = [];
        }
        return result;
      },
      addUser(item) {
        var vm = this;
        console.log(JSON.stringify(item));
        if (!this.$parent.popup.data.AddedUsers) {
          this.$parent.popup.data.AddedUsers = {};
        }
        var u = { IsConfirmed: false, UserKey: item['.key'] };
        let key = item['.key'];
        this.$parent.popup.data.AddedUsers[key] = { IsConfirmed: false, UserKey: item['.key'] };

        vm.users.find(function (usr) {
          if (usr['.key'] == key) {
            usr.IsSelected = true;
            return true;
          }
        });

        this.refreshFiltered();
        this.refreshSelected();
      },
      removeUser(item) {
        var vm = this;
        var key = item['.key'];
        delete this.$parent.popup.data.AddedUsers[key];
        vm.users.find(function (usr) {
          if (usr['.key'] == key) {
            usr.IsSelected = false;
            return true;
          }
        });

        this.refreshFiltered();
        this.refreshSelected();
      },
      setCustomerName() {
        for (var i = 0; i < this.customers.length; i++) {
          if (this.customers[i]['.key'] == this.$parent.popup.data.CustomerKey) {
            this.$parent.popup.data.CustomerName = this.customers[i].FullName;
            break;
          }
        }
      },
      setProjectName() {
        for (var i = 0; i < this.projects.length; i++) {
          if (this.projects[i]['.key'] == this.$parent.popup.data.ProjectKey) {
            this.$parent.popup.data.ProjectName = this.projects[i].Name;
            break;
          }
        }
      },
      isValid(callback) {
        if (this.$parent.popup.data.Title.trim().length <= 0) return callback(false);
        //if (this.$parent.popup.data.CustomerName.trim().length <= 0) return callback(false);
        if (this.$parent.popup.data.CustomerKey == undefined) return callback(false);
        if (this.$parent.popup.data.CustomerKey.length <= 0) return callback(false);
        //if (this.$parent.popup.data.ProjectName.trim().length <= 0) return callback(false);
        if (this.$parent.popup.data.ProjectKey.length <= 0) return callback(false);
        if (this.$parent.popup.data.Info.trim().length <= 0) return callback(false);
        //if (this.$parent.popup.data.ContractorKey.trim().length <= 0) return callback(false);
        //if (this.$parent.popup.data.InspectorKey.trim().length <= 0) return callback(false);

        callback(true);
      },
      save() {

        var vm = this;
        vm.error = "";

        //alert(JSON.stringify(this.$parent.popup.data))

        vm.isValid(function (valid) {
          if (valid == true) {
            if (vm.$parent.popup.isEdit) {
              vm.$parent.update();
            }
            else {
              vm.$parent.insert();
            }
            vm.reset();
          }
          else {
            vm.error = "נא למלא את כל השדות!"
          }
        });
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        for (var u = 0; u < this.users.length; u++) {
          this.users[u].IsSelected = false;
        }

        this.txtSearchInspector = '';
        this.txtSearchObserver = '';
        this.txtSearchContractor = '';

        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: {
            '.key': '', Title: '',
            CustomerName: '',
            CustomerKey: '',
            ProjectName: '',
            ProjectKey: '',
            CreateDate: '',
            UpdateDate: '',
            SendToCustomer: false,
            SendToInspectors: false,
            SendToContractors: false,
            Info: '',
            AddedUsers: null
          },
        };
      }
    }
  }

</script>
<style>
  .divAddedUser {
  }

  .divAddedUser:hover {
    background-color: #ddd;
  }

  .error {
    color: red;
    background-color: #fff !important;
  }

  .custom-dropdown__select{
    width: 200px;
  }

  .btnAddSmall {
    width: 20px !important;
    height: 20px !important;
    font-size: 16px !important;
    background-color: #3A2D01;
    padding-right: 2px;
    color: #fff;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// PopupDiary.vue?8de7b866